import {selector} from './selector';

const PageOrderTagProcessForm = (function ($) {

    function redirectForm() {
        $(selector.form).submit();
    }

    function initialize() {
        setTimeout(redirectForm, 2000);
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageOrderTagProcessForm};